import { render, staticRenderFns } from "./cascader-region.vue?vue&type=template&id=cb0b427a&"
import script from "./cascader-region.vue?vue&type=script&lang=js&"
export * from "./cascader-region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports